// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const ApiWorksheet: MarkdocTagRegistration = {
  tag: 'api-worksheet',
  component: 'ApiWorksheet',
};
